import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=977e0f7e&"
import script from "./BaseButton.vue?vue&type=script&lang=ts&"
export * from "./BaseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports